var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topman"},[_vm._v(" 使用情况 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }